import { render, staticRenderFns } from "./VisitorManage.vue?vue&type=template&id=2ac73202&scoped=true&"
import script from "./VisitorManage.vue?vue&type=script&lang=js&"
export * from "./VisitorManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac73202",
  null
  
)

export default component.exports